"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useActivities;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

function useActivities() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var activities = _ref.activities;
    return activities;
  })];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VBY3Rpdml0aWVzIiwidXNlU2VsZWN0b3IiLCJhY3Rpdml0aWVzIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvdXNlQWN0aXZpdGllcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IFdlYkNoYXRBY3Rpdml0eSB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWNvcmUnO1xuXG5pbXBvcnQgeyB1c2VTZWxlY3RvciB9IGZyb20gJy4vaW50ZXJuYWwvV2ViQ2hhdFJlZHV4Q29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZUFjdGl2aXRpZXMoKTogW1dlYkNoYXRBY3Rpdml0eVtdXSB7XG4gIHJldHVybiBbdXNlU2VsZWN0b3IoKHsgYWN0aXZpdGllcyB9KSA9PiBhY3Rpdml0aWVzKV07XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFFQTs7QUFFZSxTQUFTQSxhQUFULEdBQThDO0VBQzNELE9BQU8sQ0FBQyxJQUFBQyxnQ0FBQSxFQUFZO0lBQUEsSUFBR0MsVUFBSCxRQUFHQSxVQUFIO0lBQUEsT0FBb0JBLFVBQXBCO0VBQUEsQ0FBWixDQUFELENBQVA7QUFDRCJ9